<h1>Help help using TrainerFriend?</h1>
<p>
    Feeling a little lost on how to use TrainerFriend? We have created a series of short video tutorial to help you get
    started. Videos are recorded while using the app on a PC/Desktop but the process is the same using the mobile
    version.
</p>

<div class="row">

    <div class="col-lg-6">
        <iframe width="100%" style="min-height:300px;" src="https://www.youtube.com/embed/I621fmjS1Ww" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>


    </div>
    <div class="col-lg-6">

        <div class="row"><h1>Adding a new client.</h1></div>
        <div class="row">
            <p>Everything starts with a client. Learn how to add a client and the various options.<br><br><br> Once a client is created, it can always be updated by going onto Clients => General Info.</p></div>

    </div>

</div>


